$(function() {
    $(document).on('click', '.panel-custom .panel-heading .collapse-trigger', function () {
        var trigger = $(this);
        var panel = trigger.parents('.panel-custom');
        var panelBody = panel.find('.panel-body');

        if (panelBody.is(':visible')) {
            panelBody.slideUp();
            trigger.attr('class', 'fa fa-angle-double-down heading-icon collapse-trigger');
        } else {
            panelBody.slideDown();
            trigger.attr('class', 'fa fa-angle-double-up heading-icon collapse-trigger');
        }
    });

    $(document).on('click', '.cu-panel .cu-panel-header .collapse-trigger, .cu-panel .cu-panel-header .collapse-trigger', function () {
        var trigger = $(this);
        var panel = trigger.parents('.cu-panel');
        var panelBody = panel.find('.cu-panel-body');

        if (panelBody.is(':visible')) {
            panelBody.slideUp();
            trigger.attr('class', 'fa fa-angle-double-down heading-icon collapse-trigger tw-cursor-pointer');
        } else {
            panelBody.slideDown();
            trigger.attr('class', 'fa fa-angle-double-up heading-icon collapse-trigger tw-cursor-pointer');
        }
    });
});
